/**
 * Copia el texto de cada <th> del <thead> al atributo `data-label`
 * de las <td> correspondientes en el <tbody>. Esto habilita el
 * layout responsivo "tabla → lista de tarjetas" en móvil definido
 * globalmente en `src/$styles/global.scss`.
 *
 * @param {HTMLTableElement|null|undefined} tableEl
 */
export function syncResponsiveLabels(tableEl) {

    if (!tableEl || typeof tableEl.querySelectorAll !== 'function')
        return

    const headerCells = tableEl.querySelectorAll(':scope > thead > tr > th, :scope > thead > tr > td')
    if (!headerCells.length) return

    const labels = Array.from(headerCells).map(th => (th.textContent || '').trim())

    const rows = tableEl.querySelectorAll(':scope > tbody > tr')

    rows.forEach(row => {

        const cells = row.children

        for (let i = 0; i < cells.length; i++) {

            const cell = cells[i]

            if (cell.hasAttribute('data-label')) continue

            const colspan = parseInt(cell.getAttribute('colspan') || '1', 10)
            if (colspan > 1) continue

            const label = labels[i] || ''
            cell.setAttribute('data-label', label)
        }
    })
}
